import axios from 'axios';
import { PortalContext, PortalDocument, SupplierContext, SupplierOrder } from '../types';

/**
 * Client API du portail client (TF-042 → TF-046). Surface PUBLIQUE : instance axios dédiée,
 * sans en-tête d'authentification ni d'entreprise — la sécurité repose sur le jeton opaque.
 */
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1';
const publicApi = axios.create({ baseURL: BASE_URL, timeout: 15000 });

export const portalPublicService = {
  getContext: (token: string) =>
    publicApi.get<PortalContext>(`/public/portal/${token}`).then((r) => r.data),
  getDocuments: (token: string) =>
    publicApi.get<PortalDocument[]>(`/public/portal/${token}/documents`).then((r) => r.data ?? []),
  accept: (token: string, id: number) =>
    publicApi.post<PortalDocument>(`/public/portal/${token}/documents/${id}/accept`).then((r) => r.data),
  dispute: (token: string, id: number, motif: string) =>
    publicApi.post(`/public/portal/${token}/documents/${id}/dispute`, { motif }).then((r) => r.data),
};

export const supplierPortalPublicService = {
  getContext: (token: string) =>
    publicApi.get<SupplierContext>(`/public/supplier-portal/${token}`).then((r) => r.data),
  getCommandes: (token: string) =>
    publicApi.get<SupplierOrder[]>(`/public/supplier-portal/${token}/commandes`).then((r) => r.data ?? []),
  confirmDelai: (token: string, id: number, delaiJours: number) =>
    publicApi.post(`/public/supplier-portal/${token}/commandes/${id}/confirm`, { delaiJours }).then((r) => r.data),
  updateCarbon: (token: string, transportCo2ParCommande: number) =>
    publicApi.put(`/public/supplier-portal/${token}/carbone`, { transportCo2ParCommande }).then((r) => r.data),
  // TF-055 — dépôt de facture (PDF/image) + suivi des dépôts
  deposerFacture: (token: string, file: File) => {
    const form = new FormData();
    form.append('file', file);
    return publicApi.post<DepotFacture>(`/public/supplier-portal/${token}/factures`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data);
  },
  mesDepots: (token: string) =>
    publicApi.get<DepotFacture[]>(`/public/supplier-portal/${token}/factures`).then((r) => r.data ?? []),
};

// TF-055 — dépôt de facture fournisseur
export interface DepotFacture {
  id: number;
  nomFichier: string;
  numero?: string | null;
  dateFacture?: string | null;
  totalHT?: number | null;
  totalTVA?: number | null;
  totalTTC?: number | null;
  ocrProvider?: string | null;
  statut: 'RECU' | 'TRAITE' | 'REJETE';
  note?: string | null;
  fournisseurNom?: string | null;
  createdAt: string;
}
